// Client type: admin
// Name: Security Service Custom Render Components 

export const IP_ADDRESS_CUSTOM_RENDER_COMPONENTS = {};
export const KNOWN_IP_ADDRESS_CUSTOM_RENDER_COMPONENTS = {};
export const KNOWN_USER_AGENT_CUSTOM_RENDER_COMPONENTS = {};
export const USER_AGENT_CUSTOM_RENDER_COMPONENTS = {};
